/**
 * ÖDÜL — kayıp ilanındaki ödül tutarının TEK biçimlendiricisi.
 *
 * ── NEDEN AYRI BİR DOSYA ─────────────────────────────────────────────────
 *
 * 11 Eyl 2026, kullanıcı: *"kayıp kedilerin başına konulan ödüllerin hem
 * anasayfadaki kayıp kedi ilanlarının altında, hem kayıp kedi ilanlarında,
 * hem de ilan profilinde belli olmasını istiyoruz."* — ve ekledi:
 * *"zaten bu özelliğimiz vardı."*
 *
 * Doğru: sunucu tarafı 18 Ağustos 2026'da yazıldı (ÖDÜL-1..5,
 * `services/odul.py`) ve `reward_amount` / `reward_currency` `/sightings`
 * çıktısında ZATEN geliyor — izdüşüm dışlama tabanlı
 * (`{"_id": 0, "pattern_fingerprint": 0, ...}`), yani alanlar düşmüyor.
 * Eksik olan yalnızca ÜÇ EKRANIN onu çizmemesiydi.
 *
 * Ödül o gün TEK yerde çiziliyordu: `KayipSeridi.jsx`. Üç ekrana daha elle
 * kopyalamak, bu depoda defalarca ödenmiş bir bedeldi — "iki liste aynı
 * mesafeyi başka biçimde yazmasın" (`KayipIlanlari`), "iki ekran aynı kaydı
 * başka adla göstermesin" (`onemliVakalar`). Dört kopya, dördüncüsünde
 * unutulan bir para birimi demektir. Bu yüzden biçimlendirme buraya alındı
 * ve `KayipSeridi` de buraya bağlandı — yeni bir kopya EKLENMEDİ, var olan
 * kopya buraya TAŞINDI.
 *
 * ⚠️ UYGULAMA PARAYA DOKUNMUYOR. `services/odul.py` başlığındaki 18 Ağustos
 * kararı: tutar yalnızca İLANDA GÖSTERİLEN bir sayı; ödemeyi taraflar kendi
 * aralarında yapıyor. Buradaki hiçbir şey ödeme, rezerv ya da taahhüt ima
 * etmemeli — bu yüzden metin "₺2.500 ödül", "₺2.500 kazan" değil.
 */

/** Para birimi kodu → sembol. YALNIZCA GÖSTERİM.
 *
 * Liste `KayipSeridi.jsx`ten birebir taşındı, genişletilmedi: bilinmeyen bir
 * kod sembolsüz yazılır ("2.500 ödül"), yanlış sembolle DEĞİL. Yanlış para
 * birimi göstermek, ödülü olduğundan büyük ya da küçük gösterir.
 */
export const ODUL_SEMBOLU = {
  try: "₺", idr: "Rp", inr: "₹", brl: "R$", egp: "E£", pln: "zł",
  eur: "€", usd: "$",
};

/**
 * İlanda gösterilecek bir ödül var mı.
 *
 * ⚠️ SAYIYA ÇEVİRİP KARŞILAŞTIRIYOR, varlığa BAKMIYOR. Sunucu ödülsüz ilanda
 * alanı hiç yazmıyor (`odul_temizle` None döndürünce `$set`e girmiyor), ama
 * eski kayıtlarda `0` ya da `"0"` durabilir ve `Boolean("0") === true`.
 * "0 ₺ ödül" yazan bir rozet, ödül olmadığını söylemenin en kötü yoludur.
 */
export function odulVarMi(ilan) {
  return Number((ilan || {}).reward_amount) > 0;
}

/**
 * Tutarı sembolüyle yazar: `2500, "try"` → `"₺2.500"`.
 *
 * Ödül YOKSA boş dize döner — çağıran taraf `odulVarMi` ile zaten eliyor
 * ama burada da sessiz kalıyor ki yanlışlıkla "₺NaN" çizilmesin.
 *
 * `toLocaleString()` tarayıcının diline göre ayırıyor; `services/odul.py`
 * kuruş üretmiyor (tam sayıya indirgiyor), o yüzden ondalık yok.
 */
export function odulTutari(ilan) {
  const n = Number((ilan || {}).reward_amount);
  if (!Number.isFinite(n) || n <= 0) return "";
  const sembol = ODUL_SEMBOLU[(ilan || {}).reward_currency] || "";
  return `${sembol}${n.toLocaleString()}`;
}

/**
 * Rozetin tam metni: `"₺2.500 ödül"`.
 *
 * Sözcük DIŞARIDAN geliyor (`kelime`) — bu dosya i18n'e bağlanmıyor, çünkü
 * `KayipSeridi` kendi sözlüğünü taşıyor, üç yeni ekran ise `useI18n`
 * kullanıyor. Sözcüğü burada sabitlemek, ikisinden birini İngilizce
 * bırakırdı.
 */
export function odulMetni(ilan, kelime) {
  const tutar = odulTutari(ilan);
  if (!tutar) return "";
  return kelime ? `${tutar} ${kelime}` : tutar;
}

/**
 * `kayipKarti` çıktısını bu dosyanın anladığı ham biçime çevirir.
 *
 * ⚠️ NEDEN VAR: kart katmanı alanları `odul` / `odulParaBirimi` diye
 * taşıyor (Türkçe, `onemliVakalar.js`in sözlüğü), sunucu ise
 * `reward_amount` / `reward_currency`. Çeviriyi her çağıran yerde elle
 * yazmak, üç ekranın ikisinde para birimini unutmanın en kısa yoluydu —
 * `odulTutari` para birimi gelmezse sembolsüz yazar ve KİMSE fark etmez.
 * Tek satırlık bir eşleme, sessizce yanlış görünen bir ödülden ucuzdur.
 */
export function karttanOdul(kart) {
  const k = kart || {};
  return { reward_amount: k.odul, reward_currency: k.odulParaBirimi };
}
